import { combineReducers } from 'redux';
import entitiesReducer from './entities';
import softwareEntitiesReducer from './software/softwareEntities';

export default combineReducers({
  entities: entitiesReducer,
  software: softwareEntitiesReducer,
});
